const dateFieldValue = {
    day: '',
    month: '',
    year: '',
};

export default dateFieldValue;